import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { authApi, setAccessToken, presenceApi } from "../services/api";

const AdminGuard = () => {
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await authApi.me();
        if (cancelled) return;
        if (res.user?.role === "admin") {
          localStorage.setItem("adminUser", JSON.stringify(res.user));
          presenceApi.ping().catch(() => {});
          setStatus("ok");
        } else {
          setStatus("denied");
        }
      } catch {
        if (!cancelled) setStatus("denied");
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (status === "loading") {
    return (
      <div className="admin-root">
        <div className="admin-loading">Checking session…</div>
      </div>
    );
  }

  if (status === "denied") {
    return <Navigate to="/admin/login" replace />;
  }

  return <Outlet />;
};

export const adminLogout = async (navigate) => {
  try {
    await authApi.logout();
  } catch {
    /* ignore */
  }
  setAccessToken(null);
  localStorage.removeItem("adminUser");
  navigate("/admin/login", { replace: true });
};

export default AdminGuard;
